/** User-facing wording for named HTTP refusals owned by the backend.
 * Keep the code visible for support and leave unknown details untouched.
 * This is a transport presenter, not a second material or readiness registry.
 */
const KNOWN_HTTP_REFUSALS: Readonly<Record<string, string>> = {
  material_authority_not_enabled:
    'Источник материалов Viewer не подключён. Попросите администратора восстановить подключение и повторите действие.',
  CONSTRUCTOR_DEFAULT_MATERIAL_BINDING_MISSING:
    'Для этой роли не выбран подтверждённый материал по умолчанию. Попросите технолога проверить назначения материалов и повторите действие.',
};

export class HttpApiError extends Error {
  constructor(url: string, readonly status: number, readonly code: string | null, message: string) {
    super(message);
    this.name = 'HttpApiError';
  }
}

export function presentHttpError(url: string, status: number, statusText: string, detail: unknown): string {
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    const code = (detail as Record<string, unknown>).code;
    if (typeof code === 'string' && Object.prototype.hasOwnProperty.call(KNOWN_HTTP_REFUSALS, code)) {
      return `${KNOWN_HTTP_REFUSALS[code]} (код: ${code})`;
    }
  }
  const raw = detail === undefined || detail === null || detail === ''
    ? `${status} ${statusText}`
    : typeof detail === 'string' ? detail : JSON.stringify(detail);
  return `${url}: ${raw}`;
}

export async function errorFromHttpResponse(url: string, response: Response): Promise<Error> {
  let detail: unknown;
  try {
    const body = await response.json() as { detail?: unknown };
    detail = body?.detail;
  } catch {
    // A non-JSON refusal still reports its HTTP status.
  }
  const code = detail && typeof detail === 'object' && !Array.isArray(detail)
    ? (detail as Record<string, unknown>).code
    : undefined;
  return new HttpApiError(url, response.status, typeof code === 'string' ? code : null, presentHttpError(url, response.status, response.statusText, detail));
}
